module.exports = __webpack_public_path__ + "static/media/pdp_paperRecycled.7a9014ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invitations/comparison-module/pdp_paperRecycled.jpg
// module id = 1525
// module chunks = 68